import { Boolean, Literal, Record, Static, String, Union } from "runtypes";

import { getNormalEnum } from "../runtypeEnums";

const SqlSafeError = Literal("sqlsafe");
const ArrayParensError = Literal("array_parentheses");
const HexClientError = Literal("hex_client");
const DatabaseError = Literal("database");
const MemoryError = Literal("memory");
const SnowparkJinjaError = Literal("snowpark_jinja");
const JinjaQuotedParameterError = Literal("jinja_quoted_parameter");
const BigQueryOAuthExpiredError = Literal("bigquery_oauth_expired");
const BigQueryOAuthRefreshError = Literal("bigquery_oauth_refresh");
const DatabricksOAuthExpiredError = Literal("databricks_oauth_expired");
const DatabricksOAuthRefreshError = Literal("databricks_oauth_refresh");
const SnowflakeOAuthExpiredError = Literal("snowflake_oauth_expired");
const SnowflakeOAuthRefreshError = Literal("snowflake_oauth_refresh");
const NonUniqueColumnError = Literal("non_unique_column");
const InterruptedQuery = Literal("interrupted_query");
const QueryModeMultiStatement = Literal("query_mode_multi_statement");
const QueryModeNonSelect = Literal("query_mode_non_select");
const CustomImageEvent = Literal("custom_image_event");
const CalcSqlError = Literal("calc_sql_error");
const CalcParseError = Literal("calc_parse_error");
const SnowparkDataframeUsage = Literal("snowpark_dataframe_usage");
const BigqueryDataframeUsage = Literal("bigquery_dataframe_usage");
const HardRowLimitError = Literal("hard_row_limit");
const HqlCompilationError = Literal("hql_compilation_error");

const CustomErrorTypeLiteral = Union(
  SqlSafeError,
  HexClientError,
  DatabaseError,
  MemoryError,
  SnowparkJinjaError,
  JinjaQuotedParameterError,
  BigQueryOAuthExpiredError,
  BigQueryOAuthRefreshError,
  DatabricksOAuthExpiredError,
  DatabricksOAuthRefreshError,
  SnowflakeOAuthExpiredError,
  SnowflakeOAuthRefreshError,
  NonUniqueColumnError,
  InterruptedQuery,
  QueryModeMultiStatement,
  QueryModeNonSelect,
  ArrayParensError,
  CustomImageEvent,
  CalcSqlError,
  CalcParseError,
  SnowparkDataframeUsage,
  BigqueryDataframeUsage,
  HardRowLimitError,
  HqlCompilationError,
);
export type CustomErrorType = Static<typeof CustomErrorTypeLiteral>;
export const CustomErrorType = getNormalEnum(CustomErrorTypeLiteral);

export const CustomError = Record({
  errorType: CustomErrorTypeLiteral,
  traceback: String,
  magicFixable: Boolean,
});
export type CustomError = Static<typeof CustomError>;
